/**
 * CouponDashboardContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import CouponDashboardPresenter from './CouponDashboardPresenter';
import MessageAlert from 'utils';
import { CartApi, StatisticsApi, CouponApi } from 'api';
import dayjs from 'dayjs';
import Formatter from 'utils/Formatter';
// import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const CouponDashboardContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [statisticsType, setStatisticsType] = useState('month');
  const [loading, setLoading] = useState(false);
  const [couponData, setCouponData] = useState(null);

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 카트목록 조회
   * --
   */
  const getData = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await CouponApi.getCoupons();
      if (status !== 200) throw { message };

      setTimeout(() => {
        setCouponData(
          data.filter(
            (item) => item.end_date >= Formatter.dateToUnix(new Date())
          )
        );
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[CouponDashboardContainer][getData] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getData();
  }, []);

  /* ===== RENDER ===== */
  const props = {
    loading,
    chartData: couponData,
    couponData,
    permission,
    statisticsType,
    setStatisticsType,
    getData,
  };
  // JSX: start
  return (
    <>
      <CouponDashboardPresenter {...props} />
    </>
  ); // JSX: end
};

CouponDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default CouponDashboardContainer;
